package io.horion.cv.models

data class Country(
    val image: String,
    val cvname: String,
)
